import * as actions from "./actions";
import mutations from "./mutations";

const state = {};

export default {
  actions,
  mutations,
  state
};
